import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.backendReachable()) {
    return router.createUrlTree(['/unavailable']);
  }
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }
  // Compte authentifié mais non approuvé (pending/disabled) => page d'attente.
  return auth.canAccessApp() ? true : router.createUrlTree(['/pending']);
};
